import { createRoute, lazyRouteComponent, Outlet, redirect } from '@tanstack/react-router';
import { rootRoute } from '../services/routing/rootRoute';
import { routeLabels } from '../services/routing/routeMetadata';

const securityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'security',
  component: Outlet,
  staticData: { ...routeLabels('Security'), breadcrumbTo: '/security/cves' },
});

const securityIndexRoute = createRoute({
  getParentRoute: () => securityRoute,
  path: '/',
  beforeLoad: () => redirect({ to: '/security/cves', throw: true }),
});

const cvesRoute = createRoute({
  getParentRoute: () => securityRoute,
  path: 'cves',
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & { repos?: string; cve?: string } => ({
    ...search,
    repos: typeof search.repos === 'string' ? search.repos : undefined,
    cve: typeof search.cve === 'string' && search.cve ? search.cve : undefined,
  }),
  component: lazyRouteComponent(() => import('@puffin/security/cve-page'), 'CvePage'),
  staticData: { ...routeLabels('CVE Scan Results'), navigationPath: '/security/cves' },
});

export const securityRouteTree = securityRoute.addChildren([securityIndexRoute, cvesRoute]);
